<app-z-dialog
  [title]="'COMMON.ATTACH_DOCUMENTS' | translate"
  [contentTemplate]="contentWidgetDataList"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentWidgetDataList>
  @if (multiple) {
    @if (documentsFormDialog) {
      <app-widget-data-list
        [columns]="documentsColumns"
        [formControlRef]="documentsList"
        [formDialog]="documentsFormDialog"
        [customModalRef]="customDialog"
        [customModalMaxWidth]="'500px'"
        [actions]="actions"
        (dialogClosed)="documentsForm.reset()"
      >
      </app-widget-data-list>
    }
  } @else {
    <div class="s-mb-4">
      <app-file-uploader [formControlRef]="documentsForm.controls.file"></app-file-uploader>
    </div>
    <z-form-grid
      [formGroupRef]="documentsForm"
      [inputs]="documentsFormDialog.inputs"
    ></z-form-grid>
  }
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    icon="check_circle"
    [label]="'COMMON.SAVE' | translate"
    (clicked)="send()"
    cdkFocusInitial
  >
  </z-button>
</ng-template>

<ng-template #customDialog let-data let-dialogRef="dialogRef">
  <app-z-dialog
    [title]="'COMMON.NEW' | translate"
    [contentTemplate]="contentTemplate"
    [actionButtonsTemplate]="buttonsTemplate"
  >
  </app-z-dialog>

  <ng-template #contentTemplate>
    <div class="s-mb-4">
      <app-file-uploader [formControlRef]="documentsForm.controls.file"></app-file-uploader>
    </div>
    <z-form-grid
      [formGroupRef]="data.formGroup"
      [inputs]="documentsFormDialog.inputs"
    ></z-form-grid>
  </ng-template>

  <ng-template #buttonsTemplate>
    <z-button
      [disabled]="data.formGroup?.invalid"
      icon="add_circle_outline"
      [label]="'COMMON.ADD' | translate"
      (clicked)="dialogRef.close(data.formGroup.getRawValue())"
    >
    </z-button>
  </ng-template>
</ng-template>
